<div
  *ngIf="show"
  #dropdownContainer
  class="date-range-picker-dropdown"
  [class.inline-mode]="inline"
  [class.compact-mode]="compactMode"
  [class.positioning]="!inline && !isPositioned"
  [style.top]="inline ? null : dropdownPosition.top"
  [style.left]="inline ? null : dropdownPosition.left"
  (click)="onDropdownClick($event)"
>
  <div class="picker-container">
    <!-- DEBUG LABEL - Remove after testing -->
    <!-- <div style="background: #ff0; padding: 4px 8px; font-size: 11px; font-weight: bold; text-align: center; margin-bottom: 8px; border-radius: 4px;">
      MODE: {{ compactMode ? 'CARD' : 'DEFAULT' }}
    </div> -->

    <!-- Calendar Header -->
    <div class="calendar-header">
      <button class="nav-button" (click)="previousMonth()" type="button">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <path d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"/>
        </svg>
      </button>

      <div class="month-year-selector">
        <!-- Month Selector -->
        <div class="month-selector-container">
          <span class="month-text" (click)="toggleMonthDropdown($event)">
            {{ months[currentMonth.getMonth()] }}
          </span>

          <!-- Month Dropdown -->
          <div class="month-dropdown" *ngIf="showMonthDropdown" (click)="$event.stopPropagation()">
            <div class="month-grid">
              <button
                *ngFor="let month of monthsShort; let i = index"
                class="month-item"
                [class.active]="i === currentMonth.getMonth()"
                (click)="selectMonth(i, $event)"
                type="button"
              >
                {{ month }}
              </button>
            </div>
          </div>
        </div>

        <!-- Year Selector -->
        <div class="year-selector-container">
          <span class="year-text" (click)="toggleYearDropdown($event)">
            {{ currentMonth.getFullYear() }}
          </span>

          <!-- Year Dropdown -->
          <div class="year-dropdown" *ngIf="showYearDropdown" (click)="$event.stopPropagation()">
            <div class="year-header">
              <button class="year-nav-button" (click)="previousYearRange()" type="button">
                <svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"/>
                </svg>
              </button>
              <span class="year-range-display">{{ yearRanges[0] }} - {{ yearRanges[yearRanges.length - 1] }}</span>
              <button class="year-nav-button" (click)="nextYearRange()" type="button">
                <svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"/>
                </svg>
              </button>
            </div>
            <div class="year-grid">
              <button
                *ngFor="let year of yearRanges"
                class="year-item"
                [class.active]="year === currentMonth.getFullYear()"
                (click)="selectYear(year, $event)"
                type="button"
              >
                {{ year }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <button class="nav-button" (click)="nextMonth()" type="button">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <path d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"/>
        </svg>
      </button>
    </div>

    <!-- Week Days Header -->
    <div class="week-days">
      <div class="week-day" *ngFor="let day of weekDays">{{ day }}</div>
    </div>

    <!-- Calendar Grid -->
    <div class="calendar-grid">
      <div class="calendar-week" *ngFor="let week of calendarDays">
        <button
          *ngFor="let date of week"
          type="button"
          class="calendar-day"
          [class.empty]="!date"
          [class.today]="isToday(date)"
          [class.selected]="isSelected(date)"
          [class.in-range]="isInRange(date)"
          [class.range-start]="isRangeStart(date)"
          [class.range-end]="isRangeEnd(date)"
          [class.disabled]="isDisabled(date)"
          [disabled]="!date || isDisabled(date)"
          (click)="selectDate(date)"
          (mouseenter)="onDateHover(date)"
        >
          {{ date ? date.getDate() : '' }}
        </button>
      </div>
    </div>
  </div>
</div>
